/* tslint:disable */
/* eslint-disable */
/**
 * Hyper GES API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EmergenzaUpdateDTO
 */
export interface EmergenzaUpdateDTO {
    /**
     * 
     * @type {string}
     * @memberof EmergenzaUpdateDTO
     */
    nome?: string;
    /**
     * 
     * @type {Date}
     * @memberof EmergenzaUpdateDTO
     */
    dataInizio?: Date;
    /**
     * 
     * @type {Date}
     * @memberof EmergenzaUpdateDTO
     */
    dataFine?: Date;
    /**
     * 
     * @type {string}
     * @memberof EmergenzaUpdateDTO
     */
    note?: string;
}

/**
 * Check if a given object implements the EmergenzaUpdateDTO interface.
 */
export function instanceOfEmergenzaUpdateDTO(value: object): value is EmergenzaUpdateDTO {
    return true;
}

export function EmergenzaUpdateDTOFromJSON(json: any): EmergenzaUpdateDTO {
    return EmergenzaUpdateDTOFromJSONTyped(json, false);
}

export function EmergenzaUpdateDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): EmergenzaUpdateDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'nome': json['nome'] == null ? undefined : json['nome'],
        'dataInizio': json['dataInizio'] == null ? undefined : (new Date(json['dataInizio'])),
        'dataFine': json['dataFine'] == null ? undefined : (new Date(json['dataFine'])),
        'note': json['note'] == null ? undefined : json['note'],
    };
}

export function EmergenzaUpdateDTOToJSON(value?: EmergenzaUpdateDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'nome': value['nome'],
        'dataInizio': value['dataInizio'] == null ? undefined : ((value['dataInizio']).toISOString()),
        'dataFine': value['dataFine'] == null ? undefined : ((value['dataFine'] as any).toISOString()),
        'note': value['note'],
    };
}

